import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import './index.css';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import RestaurantsV2 from './pages/Restaurants';
import Restaurants from './pages/v1/Restaurants';
// import reportWebVitals from './reportWebVitals';
import Detail from './pages/MenuDetails';
import RestaurantMenuV2 from './pages/RestaurantMenu';
import RestaurantKiosk from './pages/RestaurantKiosk';
import RestaurantTogether from './pages/RestaurantTogether';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/v1/Profile';
import ProfileV2 from './pages/Profile';
import Orders from './pages/Orders';
import Wallet from './pages/Wallet';
import QrLanding from './pages/QrLanding';
import Staff from './pages/Staff';
import Events from './pages/Events';
import Ticket from './pages/Ticket';
import EventConfirmation from './pages/Events/Confirmation';
import EventTerms from './pages/Events/Terms';
import { Provider } from 'react-redux';
import store from './store';
import ApiRedirect from './ApiReturnUrl';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { NotificationWrapper } from './context/notification';
import { OrderWrapper } from './context/order';
import { RestaurantWrapper } from './context/restaurants';
import { StampWalletWrapper } from './context/stampWallet';
import { DataWrapper } from './context/data';
import ErrorBoundaries from './components/ErrorBoundary';
import Survey from './pages/Survey';
import Survey2 from './pages/Survey/page2';
import './firebase';
import { installAuthInterceptors, refreshOnAppOpen } from './utils/authSession';
import SessionExpiryWatcher from './components/SessionExpiryWatcher';
import DeliveryTracker from './components/DeliveryTracker';

// Lazy-loaded so the bundles are only fetched when the route is visited.
const HeyWaitrPlus = lazy(() => import('./pages/HeyWaitrPlus'));
const Perks = lazy(() => import('./pages/Perks'));

// Request interceptors for API calls
axios.interceptors.request.use(
  (config) => {
    config.headers['accept-language'] = `${localStorage.getItem('user_lang')}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Refreshes the customer access token before it expires and retries on 401.
installAuthInterceptors();
// Rotate the token pair on every app open, before any authenticated request.
refreshOnAppOpen();

export default function Home() {
  return (
    <ErrorBoundaries>
      <DataWrapper>
        <NotificationWrapper>
          <OrderWrapper>
            <RestaurantWrapper>
              <StampWalletWrapper>
                <SessionExpiryWatcher />
                <BrowserRouter>
                  <Layout>
                    <Routes>
                      <Route exact path="/" element={<RestaurantsV2 />}></Route>
                      <Route exact path="/restaurants" element={<RestaurantsV2 />} />
                      <Route exact path="/v1" element={<Restaurants />}></Route>
                      <Route exact path="/v1/restaurants" element={<Restaurants />} />
                      <Route exact path="/start" element={<LandingPage />} />
                      <Route exact path="/v1/restaurants/:id" element={<Detail />} />

                      {/* Route to support nested routing */}
                      <Route exact path="/restaurants/:id*" element={<RestaurantMenuV2 />} />
                      <Route exact path="/restaurant-kiosk/:id*" element={<RestaurantKiosk />} />
                      <Route
                        exact
                        path="/restaurant-together/:id*"
                        element={<RestaurantTogether />}
                      />

                      <Route exact path="/api/redirect" element={<ApiRedirect />} />
                      <Route exact path="/login" element={<Login />} />
                      <Route exact path="/register" element={<Register />} />
                      <Route exact path="/v1/profile" element={<Profile />} />
                      <Route exact path="/profile" element={<ProfileV2 />} />
                      <Route exact path="/orders" element={<Orders />} />
                      {/* keyed apart from /orders, so the open tab does not carry over */}
                      <Route exact path="/order-history" element={<Orders history key="history" />} />
                      <Route exact path="/wallet" element={<Wallet />} />
                      <Route exact path="/q/:token" element={<QrLanding />} />
                      <Route exact path="/staff" element={<Staff />} />
                      {/* Billetsalg — TICKETING-SPEC.md §4 / §5.3. /t/:code is the
                        guest's ticket; the code IS the credential, so there is no
                        session on it, exactly like a paper ticket. */}
                      <Route exact path="/events/:restaurantId" element={<Events />} />
                      <Route
                        exact
                        path="/events/:restaurantId/kvittering"
                        element={<EventConfirmation />}
                      />
                      <Route exact path="/events/:restaurantId/betingelser" element={<EventTerms />} />
                      <Route exact path="/events/:restaurantId/:eventId/betingelser" element={<EventTerms />} />
                      <Route exact path="/t/:code" element={<Ticket />} />
                      <Route
                        exact
                        path="/heywaitr-plus"
                        element={
                          <Suspense fallback={null}>
                            <HeyWaitrPlus />
                          </Suspense>
                        }
                      />
                      <Route
                        exact
                        path="/perks"
                        element={
                          <Suspense fallback={null}>
                            <Perks />
                          </Suspense>
                        }
                      />
                      <Route exact path="/survey" element={<Survey />} />
                      <Route exact path="/survey-2" element={<Survey2 />} />
                      {/* https://heywaitr-staging.herokuapp.com/api/order/acceptaddcard?id=cs_e9159d4d0ca6cbd4642ab8e44a94eec8&customer=6238877c5af15f00162f28e9&payment_method=ca_2dd1a65bdb68704955b43829c6c9b226 */}
                    </Routes>
                    <DeliveryTracker />
                    <ToastContainer
                      position="bottom-center"
                      autoClose={1000}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light"
                    />
                  </Layout>
                </BrowserRouter>
              </StampWalletWrapper>
            </RestaurantWrapper>
          </OrderWrapper>
        </NotificationWrapper>
      </DataWrapper>
    </ErrorBoundaries>
  );
}

// ReactDOM.render(<Provider store={store}><Home/></Provider>, document.getElementById("root"));
// ReactDOM.render(<GoogleOAuthProvider clientId="356128359500-hmkgrgcckeo25hi8g2rmsfhl1tkci1ue.apps.googleusercontent.com"><Home/></GoogleOAuthProvider>, document.getElementById("root"));
ReactDOM.render(
  <GoogleOAuthProvider clientId="824346593925-cb7tb47r3duqvo4vhm0ehkepbkprcblr.apps.googleusercontent.com">
    <Home />
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);

// menu_title
